import PARENT from '../types';

export const SET_GRAPH_TICKS = `${PARENT}/SET_GRAPH_TICKS`;
